import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiUrl } from '../../url';

export const JWT = localStorage.getItem('jwt');

const initialState = {
  loading: false,
  user: [],
  error: '',
};

//logout service
export const LogoutAction = createAsyncThunk('user/logout', async () => {
  try {
    const response = await axios({
      method: 'POST',
      url: `${apiUrl}/api/users/auth/logout`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        withCredentials: true,
      },
    });
    return response;
  } catch (err) {
    console.log(err);
  }
});

//login service
export const LoginAction = createAsyncThunk(
  'user/login',

  async (obj) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${apiUrl}/api/users/auth/login`,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          withCredentials: true,
        },
        data: {
          email: obj.email,
          password: obj.password,
        },
      });
      return response.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //login
    builder.addCase(LoginAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(LoginAction.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload;
      state.error = '';
    });
    builder.addCase(LoginAction.rejected, (state, action) => {
      state.loading = false;
      state.user = [];
      state.error = action.error.message;
    });

    //logout
    builder.addCase(LogoutAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(LogoutAction.fulfilled, (state, action) => {
      state.loading = false;
      state.user = action.payload;
      state.error = '';
    });
    builder.addCase(LogoutAction.rejected, (state, action) => {
      state.loading = false;
      state.user = [];
      state.error = action.error.message;
    });
  },
});
export default authSlice.reducer;
